// extracted by mini-css-extract-plugin
export var footerCopyright = "footer-module--footer-copyright--7ac66";
export var footerLogo = "footer-module--footer-logo--7c0f4";
export var footerMenu = "footer-module--footer-menu--ca680";
export var footerMenuTitle = "footer-module--footer-menu-title--0e4bb";
export var footerMenus = "footer-module--footer-menus--a2099";
export var footerSocials = "footer-module--footer-socials--4edfe";
export var menuItem = "footer-module--menu-item--e1786";
export var opened = "footer-module--opened--d7898";
export var trialButton = "footer-module--trial-button--704a2";